export function getBorderStyleString(value: number, borderStyle: string, borderColor: string): string {
  return value !== 0 ? `${value}px ${borderStyle} ${borderColor}` : null;
}
